module.exports = __webpack_public_path__ + "static/media/JM.8a8dbeed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/JM.svg
// module id = 2179
// module chunks = 7